/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import { css } from 'styled-components';
import { IconContext } from 'react-icons';
import { FaCheck } from 'react-icons/fa'; 

const checkboxContainer = css`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
`;

const errorMessageStyle = css`
  display: flex;
  align-items: flex-start;
  color: red;
  margin: 15px 0px;
  .exclamation-icon {
    font-size: 24px;
    margin-right: 1rem;
  }
`;

const checkboxWrapper = css`
  display: flex;
  align-items: start;
  justify-content: flex-start;
  margin-top: 24px;

  label {
    position: relative;
    margin-right: 2rem;
    width: 1.5rem;
    height: 1.5rem;
    cursor: pointer;
    user-select: none;

    & .checkmark {
      background-color: var(--white);
      vertical-align: middle;
      width: 100%;
      height: 100%;
      display: inline-block;
      border: 1px solid #999999;
      border-radius: 2px;
    }

    & .check-icon {
      position: absolute;
      top: 5px;
      left: 4px;
      font-size: 1rem;
      color: var(--red);
      opacity: 0;
      transition: opacity 0.4s ease-in-out;
    }

    input {
      display: none;
      appearance: none;
      font-family: inherit;
      font-size: 100%;
    }

    & input:checked + .check-icon {
      opacity: 100;
    }
  }

  .hint {
    width: 90%;
    margin-top: 2px;
    margin-left: -10px;
  }

  .checkbox-link {
    text-decoration: underline !important;
  }

  .checkbox-link:hover {
    color: #E60000;
}
`;

type CheckboxProps = {
  name: string;
  label: string;
  value: boolean;
  onChange: () => void;
  hint?: {
    hint: string;
  };
  required?: boolean;
  errorMessage?: string;
};

const Checkbox = ({
  name,
  label,
  value,
  onChange,
  hint,
  required,
  errorMessage,
}: CheckboxProps) => {
  const createHint = (hint: string) => {
    const checkboxHint = <span className="hint">{hint}</span>;
    const startIndex = hint.indexOf('[');
    const endIndex = hint.indexOf(']', startIndex + 1);
    if (startIndex === -1 || endIndex === -1) {
      return checkboxHint;
    } else {
      const linkString = hint.substring(startIndex + 1, endIndex);
      const slicedLink = linkString.split("|");

      return (
        <span className="hint">
          {hint.slice(0, startIndex)}
          <a className="checkbox-link" target="_blank"  href={slicedLink[1].trim()}>{slicedLink[0].trim()}</a>
          {hint.slice(endIndex+1)}
        </span>
      );
    }
  };

  return (
    <div css={checkboxContainer}>
      <div css={checkboxWrapper}>
        <label htmlFor={name}>
          <input
            id={name}
            name={name}
            type="checkbox"
            required={required}
            checked={value}
            onChange={onChange}
          />
          <IconContext.Provider value={{ className: 'check-icon' }}>
            <FaCheck />
          </IconContext.Provider>
          <span className="checkmark"></span>
          {label}
        </label>
        {createHint(hint)}
      </div>
      {errorMessage && (
        <div css={errorMessageStyle}>
          <span>{errorMessage}</span>
        </div>
      )}
    </div>
  );
};

export default Checkbox;
